import React from 'react';
import { useTranslation } from 'react-i18next';

export const GenerateGuidanceList: React.FC = () => {
  const { t } = useTranslation('traffic_monitor');

  const guidanceDefinitions = [
    t(
      'When_attempting_to_retry_a_request,_always_retry_the_most_recent_first',
      'When attempting to retry a request, always retry the most recent first'
    ),
    t('Only_one_request_at_a_time', 'Only one request at a time'),
    t(
      'Refresh_the_table_in_order_to_see_the_updated_status',
      'Refresh the table in order to see the updated status'
    ),
    t(
      'If_a_request_fails_after_retrying,_please_move_to_the_next_-_request',
      'If a request fails after retrying, please move to the next - request'
    ),
    t(
      'Contact_the_system_administrator_if_a_request_continues_to_fail',
      'Contact the system administrator if a request continues to fail'
    ),
  ];

  return (
    <ul>
      {guidanceDefinitions.map((e) => {
        return (
          <li style={{ fontSize: '34px', marginBottom: '5px' }} key={e}>
            <span
              style={{
                fontSize: '16px',
                verticalAlign: 'middle',
                letterSpacing: '-0.2px',
                lineHeight: '24px',
              }}
            >
              {e}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
